import { FC } from "react";
import { Box, Card, Typography, useTheme } from "@mui/material";
import UserAvatar from "../../../../components/ui/UserAvatar";

type Props = {
  name: string;
  occupation: string;
  email: string;
};

/** Card de identidade do perfil (avatar + nome + ocupação + e-mail). */
const ProfileSummaryCard: FC<Props> = ({ name, occupation, email }) => {
  const theme = useTheme();

  return (
    <Card
      variant="outlined"
      sx={{ borderRadius: "18px", p: "30px 24px", textAlign: "center", borderColor: "divider", bgcolor: "background.paper" }}
    >
      <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
        <UserAvatar label={name || "?"} size={88} variant="surface" />
      </Box>

      <Typography sx={{ fontFamily: theme.typography.fontFamilyDisplay, fontSize: "1.625rem", lineHeight: 1.2, color: "text.primary", mb: 0.5 }}>
        {name || "—"}
      </Typography>
      <Typography sx={{ fontSize: "0.8125rem", fontWeight: 600, color: "primary.main", mb: 0.5 }}>{occupation}</Typography>
      <Typography sx={{ fontSize: "0.8125rem", color: "text.secondary", wordBreak: "break-all" }}>{email}</Typography>
    </Card>
  );
};

export default ProfileSummaryCard;
